var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._v("© 2023 武汉摩鸣科技有限公司 版权所有 "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.open}},[_vm._v("鄂ICP备18014157号-3")])])
}
var staticRenderFns = []

export { render, staticRenderFns }